module.exports = __webpack_public_path__ + "86415d9cf1cc15515af2ebcbad2e733a.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/caratScale/0.50ct.png
// module id = 807
// module chunks = 0